import React from 'react';
import PinIcon from 'images/icons/logos/pin.svg?react-svg';
import DropIcon from 'images/icons/logos/drop.svg?react-svg';
import styles from './Avatar.mod.scss';

export default function GiftClaimAvatar({ user }) {
  const imageUrl = user ? user.fb_avatar_url : null;

  if (imageUrl) {
    return (
      <div className={styles.avatarContainer}>
        <PinIcon width={64} height={85} />
        <img src={imageUrl} className={styles.avatar} />
      </div>
    );
  }

  const initial = user ? user.first_name.slice(0, 1) : '';

  return (
    <div className={styles.avatarContainer}>
      <DropIcon width={50} height={68} />
      <span className={styles.initial}>{initial}</span>
    </div>
  );
}
